var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTripadvisorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "9oleh5j9ka",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1198 -116) translate(1198 116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "30r9bz3ptb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9oleh5j9ka"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#9oleh5j9ka"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B790",
    d: "M12.399 6.526c3.411 0 4.696 1.408 4.696 1.408s-3.65-.603-4.866 3.856C11.014 7.33 7.365 7.934 7.365 7.934s1.284-1.408 4.696-1.408h.338zm4.155 6.053c0 .436.363.79.81.79.449 0 .811-.354.811-.79 0-.436-.362-.79-.81-.79-.448 0-.811.354-.811.79zm-.527 1.303c-.357-.348-.554-.81-.554-1.303 0-.492.197-.954.554-1.302.357-.349.833-.54 1.338-.54 1.043 0 1.891.827 1.891 1.842 0 1.016-.848 1.842-1.891 1.842-.505 0-.98-.191-1.338-.54 0 0 .357.349 0 0zm-.382-2.978c-.46.448-.713 1.042-.713 1.675s.253 1.228.713 1.675c.46.447 1.07.694 1.72.694 1.341 0 2.432-1.063 2.432-2.369 0-1.306-1.091-2.369-2.433-2.369-.65 0-1.26.247-1.72.694zm1.72 5.622c-2.236 0-4.054-1.77-4.054-3.947s1.818-3.948 4.053-3.948c2.236 0 4.055 1.771 4.055 3.948s-1.82 3.947-4.055 3.947zM6.823 12.58c0 .436.363.79.811.79.448 0 .811-.354.811-.79 0-.436-.363-.79-.811-.79-.448 0-.811.354-.811.79zm-.527 1.303c-.357-.348-.554-.81-.554-1.303 0-.492.197-.954.554-1.302.358-.349.833-.54 1.338-.54 1.043 0 1.892.827 1.892 1.842 0 1.016-.849 1.842-1.892 1.842-.505 0-.98-.191-1.338-.54 0 0 .358.349 0 0zm-.382-2.978c-.46.448-.713 1.042-.713 1.675s.254 1.228.713 1.675c.46.447 1.07.694 1.72.694 1.342 0 2.433-1.063 2.433-2.369 0-1.306-1.091-2.369-2.433-2.369-.65 0-1.26.247-1.72.694zm1.72 5.622c-2.235 0-4.054-1.77-4.054-3.947S5.4 8.631 7.635 8.631c2.235 0 4.054 1.771 4.054 3.948s-1.819 3.947-4.054 3.947zM21.36 9.49c.19-.557.481-1.212.883-1.608h-3.316c-.055-.016-.112-.027-.168-.042C18.58 7.563 17.345 6 12.414 6c-5.411 0-6.37 1.882-6.37 1.882h-3.46c.442.433.749 1.179.937 1.765-.638.83-1.021 1.858-1.021 2.975 0 2.734 2.265 4.957 5.051 4.957 1.544 0 2.927-.685 3.854-1.76l1.146 1.576.99-1.637c.927 1.11 2.334 1.82 3.908 1.82 2.785 0 5.051-2.222 5.051-4.956 0-1.187-.429-2.278-1.14-3.132z",
    mask: "url(#30r9bz3ptb)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTripadvisorCircle);
export default __webpack_public_path__ + "static/media/IcoTripadvisorCircle.f4831c77edebf9d88786890d73ffd3ce.svg";
export { ForwardRef as ReactComponent };